import { useEffect, useState } from "react";
import "./homePage.scss";

import { Typography, Grid, Box } from "@mui/material";

import ReactFullpage from "@fullpage/react-fullpage";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router";
import SearchTask from "../../components/SearchTask/SearchTask";
import picture0 from "../../constants/img/Protein.png";

function AnimatedTitle() {
  const [show, setShow] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);

  useEffect(() => {
    let t = setTimeout(() => {
      setShow(true);
    }, 500);
    let t2 = setTimeout(() => {
      setShowSearchBar(true);
    }, 2000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  });
  return (
    <div className="animation-page">
      <div className={"parts-group" + (show ? " show" : "")}>
        <div className="text-left"></div>
        <div className="smart-art">
          <div className="smart-art-title">DeepPEP</div>
        </div>
        <div className="text-right"></div>
      </div>
      <Box height={100} marginTop={5}>
        <SearchTask />
      </Box>
    </div>
  );
}

function Workflow(parameters) {
  return (
    <div className="content">
      <Typography variant="h3" component="div" className="title">
        {parameters.title}
      </Typography>
      <Typography variant="p" component="ol">
        <Grid container spacing={2} direction="row">
          <Grid item xs={6}>
            {parameters.content}
          </Grid>
          <Grid item xs={6}>
            <img src={parameters.img} className="introduction-image" />
          </Grid>
        </Grid>
      </Typography>
    </div>
  );
}

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="homepage-body">
      <ReactFullpage
        navigation
        render={({ state, fullpageApi }) => (
          <ReactFullpage.Wrapper>
            <div className="section">
              <AnimatedTitle />
            </div>
            <div className="section" style={{ width: "100%" }}>
              <div
                style={{
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "40%",
                    float: "left",
                    marginRight: "20px",
                    padding: "6%",
                  }}
                >
                  <img style={{ width: "100%" }} src={picture0} />
                </div>
                <div
                  className="quick-entry-page"
                  style={{
                    width: "60%",
                    // float: "left",
                    fontSize: "20px",
                    // margin:"0 auto",
                    lineHeight: "30px",
                    textAlign: "justify",
                    color: "#2c3e50",
                  }}
                >
                  <Typography
                    variant="h4"
                    component="div"
                    className="title"
                    fontWeight="bold"
                    // fontFamily= "Roboto"
                  >
                    What is DeepPEP?
                  </Typography>
                  <Typography variant="p" component="div" className="content">
                    DeepPEP is a user-friendly interpretable deep-learning
                    platform for detecting peptides and predicting their
                    structures and functions in an automated pipeline.
                    Specifically, DeepPEP enables the accurate prediction of
                    peptide detectability to discover bioactive peptides from
                    large-scale proteins, and then predicts the secondary
                    structures and functions of the bioactive peptides to
                    discover the therapeutic properties of the peptides, such as
                    anti-cancer activity, and anti-inflammatory activity, etc.
                    Furthermore, DeepPEP integrates seven advanced deep
                    learning-based models with an intuitive and comprehensive
                    visualization analysis. Extensive evaluations and
                    validations demonstrate that DeepPEP exceeds the performance
                    of the existing models and provides promising predictions.
                    DeepPEP is an easy-to-use, interpretable, and highly
                    accurate platform assisting in complex functional mining and
                    contributing to the advancement of peptide drug discovery.
                  </Typography>
                </div>
              </div>
            </div>

            <div className="section fp-auto-height">
              <Footer />
            </div>
          </ReactFullpage.Wrapper>
        )}
      />
    </div>
  );
}
